import { createFetchInstance } from './fetch-utils/index'
import { getToken } from '../utils/token-util'

const TOKEN_HEADER = 'x-access-token'

const fetchInstanceGold = createFetchInstance()
fetchInstanceGold.init(() => {
  // fetchInstanceGold.addRequestMiddleware(async (config, meta) => {
  //   // 获取必要的信息从本地存储
  //   const token = getToken();
  //   let language = localStorage.getItem("i18n");
  //   let companyIdStr = localStorage.getItem("companyId");
  //   let userCode = localStorage.getItem("userCode");
  //   if (!language) {
  //     language = "en";
  //   }

  //   // 确保headers存在
  //   if (!config.headers) {
  //     config.headers = {};
  //   }

  //   // token处理
  //   if (token) {
  //     config.headers[TOKEN_HEADER] = token;
  //   }

  //   // 创建URL对象来处理GET请求的查询参数
  //   if (config.method === "GET") {
  //     const url = new URL(config.url, config.baseUrl || window.location.origin);
      
  //     // 添加参数到URL
  //     if (language) url.searchParams.append("language", language);
  //     if (userCode) url.searchParams.append("userCode", userCode);
  //     if (token) url.searchParams.append("token", token);
      
  //     // 处理公司ID
  //     if (companyIdStr && companyIdStr !== "" && companyIdStr !== "undefined") {
  //       const companyId = parseInt(companyIdStr);
  //       url.searchParams.append("companyId", companyId.toString());
  //     }
      
  //     // 更新URL
  //     config.url = url.pathname + url.search;
  //   } 
  //   // 处理POST请求的请求体
  //   else if (config.method === "POST") {
  //     let body = {};
      
  //     // 如果已经有body，先解析它
  //     if (config.body) {
  //       try {
  //         body = JSON.parse(config.body as string);
  //       } catch (e) {
  //         // 如果不是JSON，保持原样
  //         body = { originalBody: config.body };
  //       }
  //     }
      
  //     // 添加参数到body
  //     if (language) body = { ...body, language };
  //     if (userCode) body = { ...body, userCode };
  //     if (token) body = { ...body, token };
      
  //     // 处理公司ID
  //     if (companyIdStr && companyIdStr !== "" && companyIdStr !== "undefined") {
  //       const companyId = parseInt(companyIdStr);
  //       body = { ...body, companyId };
  //     }
      
  //     // 更新body
  //     config.body = JSON.stringify(body);
  //   }

  //   // 设置 baseUrl
  //   const hostname = window.location.hostname;
  //   const apiUrlMap = {
  //     localhost: "https://jiaoyiys.icu", //"http://127.0.0.1:1084",
  //     "206.238.199.169": "https://jiaoyiys.icu",
  //   };
  //   const BASE_API_URL = apiUrlMap[hostname] ? apiUrlMap[hostname] : "";

  //   if (!meta.def.baseUrl) {
  //     config.baseUrl = BASE_API_URL || "";
  //   }

  //   return config;
  // })

  fetchInstanceGold.addErrorMiddleware(
    (err: { response: { status: number }; message: string }, config) => {
    }
  )
})

const { useFetch: useFetchGold, createFetchClient: createFetchClientGold, defineRequest: defineRequestGold, refreshApi: refreshApiGold } = fetchInstanceGold

export { useFetchGold, createFetchClientGold, defineRequestGold, refreshApiGold }
